const url = {
    register: '/org-arch-core/user/register-by-mobile-with-pwd', // 注册
    login: '/org-arch-core/session/login-by-password', // 登录
    addOrder: '/mc-twirls/order/create', // 订单新增
    addFeedback: '/mc-twirls/feedback/create', // 联系我们 新增
    getReportListPageList: '/mc-twirls/report/list', // 报告中心列表
    getReportDetail: '/mc-twirls/report/detail/{id}', // 报告详情 其中content为大JSON
    getEnterpriseCaseList: '/mc-twirls/enterprise-case/list', // 企业案例 分页列表
    getEnterpriseCaseDetail: '/mc-twirls/enterprise-case/detail/{id}', // 获取案例详情
    getSimpleCaseDetail: '/mc-twirls/simple-case/detail/{id}', // 获取简单案例详情
    getReportClassList: '/mc-twirls/report/timeline-class/list', // 获取案例报告Timeline Class列表 1
    getReportKpDetail: '/mc-twirls/report/kp/detail', // 获取报告KP内容 2
    getReportKpList: '/mc-twirls/report/kp/list', // 获取报告KP列表 3
    getSimpleCaseKpDetail: '/mc-twirls/simple-case/kp/detail', // 获取报告KP内容 4
    getSimpleCaseKpList: '/mc-twirls/simple-case/kp/list', // 获取报告KP列表 5
    getSimpleClassList: '/mc-twirls/simple-case/timeline-class/list', // 获取报告Timeline Class列表 6
    getSimpleCaseList: '/mc-twirls/simple-case/list', // 简单案例 分页列表
    updatePasswordBySelf: '/org-arch-core/user/update-password-by-self', // 修改当前登录用户密码
    updateUserInfo: '/org-arch-core/user/update-current', // 修改当前登录用户信息
    getUserInfo: '/org-arch-core/user/detail/{id}', // 根据id获取用户信息
    getReportPageList: '/mc-twirls/report/list', // 报告列表
    getContactInfo: '/mc-twirls/contact/info', // 获取联系方式
    getWordDictList: '/mc-twirls/word-dict/list', // 专业术语词典列表
    getPackageList: '/mc-twirls/ms-package/list',// 套餐管理表 根据条件查询page信息
    getCodeUrl: "/mc-twirls/bff/pay", //获取支付的url
    getPayRecord: "/mc-twirls/bench-pay/api/query-order-pay-record", //查询支付状态
    getTableList: '/mc-twirls/ms-order/list', //获取交易明细列表
    getInvoiceNow: '/mc-twirls/ms-invoice-record/invoicing', //立即开票
};

export default url
